
export default function CaseStudies() {
  const cases = [
    {
      company: '글로벌 이커머스 기업',
      industry: '이커머스',
      challenge: '하루 수천 건의 고객 문의 처리로 인한 높은 운영 비용',
      solution: 'AI 챗봇 및 자동 응답 시스템 구축',
      results: [
        '고객 응대 시간 65% 단축',
        '운영 비용 40% 절감',
        '고객 만족도 25% 향상'
      ],
      image: 'https://static.readdy.ai/image/d59b18a86b2c4da172af70cd0d419253/9aebef5c26523df5af1d3e31372a40ec.png',
      color: 'from-teal-500 to-cyan-600'
    },
    {
      company: '제조업 선도 기업',
      industry: '제조',
      challenge: '복잡한 생산 데이터 분석 및 품질 관리의 어려움',
      solution: 'AI 기반 예측 분석 및 품질 관리 시스템',
      results: [
        '불량률 50% 감소',
        '생산 효율성 35% 증가',
        '예측 정확도 92% 달성'
      ],
      image: 'https://static.readdy.ai/image/d59b18a86b2c4da172af70cd0d419253/7de01e6b5674783bf7545b7a56e05141.png',
      color: 'from-cyan-500 to-teal-600'
    },
    {
      company: '금융 서비스 기업',
      industry: '금융',
      challenge: '대량의 문서 처리 및 규정 준수 검토 업무',
      solution: 'AI 문서 자동화 및 컴플라이언스 시스템',
      results: [
        '문서 처리 시간 80% 단축',
        '오류율 95% 감소',
        '규정 준수율 100% 달성'
      ],
      image: 'https://public.readdy.ai/ai/img_res/b1e12952a8b8249a5729aafe0206db19.jpg',
      color: 'from-teal-600 to-cyan-500'
    }
  ];

  return (
    <section id="cases" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-50 rounded-full px-4 py-2 mb-4">
            <i className="ri-trophy-line text-teal-600"></i>
            <span className="text-teal-600 text-sm font-semibold">Success Stories</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            고객 성공 사례
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            다양한 산업 분야에서 검증된 AI 자동화 솔루션의 실제 성과를 확인하세요
          </p>
        </div>

        <div className="space-y-8">
          {cases.map((caseStudy, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                <div className="relative h-80 lg:h-auto">
                  <img 
                    src={caseStudy.image}
                    alt={caseStudy.company}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className={`absolute top-6 left-6 bg-gradient-to-r ${caseStudy.color} text-white px-4 py-2 rounded-lg text-sm font-semibold`}>
                    {caseStudy.industry}
                  </div>
                </div>

                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                    {caseStudy.company}
                  </h3>

                  <div className="space-y-6">
                    <div>
                      <div className="flex items-start space-x-3 mb-2">
                        <i className="ri-error-warning-line text-red-500 text-lg mt-1"></i>
                        <div>
                          <div className="text-sm font-semibold text-gray-700 mb-1">과제</div>
                          <p className="text-gray-600">{caseStudy.challenge}</p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="flex items-start space-x-3 mb-2">
                        <i className="ri-lightbulb-line text-teal-500 text-lg mt-1"></i>
                        <div>
                          <div className="text-sm font-semibold text-gray-700 mb-1">솔루션</div>
                          <p className="text-gray-600">{caseStudy.solution}</p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="flex items-start space-x-3">
                        <i className="ri-bar-chart-box-line text-teal-500 text-lg mt-1"></i>
                        <div className="flex-1">
                          <div className="text-sm font-semibold text-gray-700 mb-3">성과</div>
                          <div className="grid grid-cols-1 gap-2">
                            {caseStudy.results.map((result, idx) => (
                              <div key={idx} className="flex items-center space-x-2 bg-teal-50 rounded-lg px-4 py-2">
                                <i className="ri-check-line text-teal-600"></i>
                                <span className="text-sm font-medium text-gray-800">{result}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
